import React, { useState } from "react";
import FAQPopup from "./FAQPopup"; // Import the FAQPopup component
import { FaInstagram, FaLinkedin, FaYoutube, FaUserCircle } from "react-icons/fa"; // Import icons

const Footer = () => {
  const [isFAQOpen, setIsFAQOpen] = useState(false);

  const openFAQPopup = () => setIsFAQOpen(true);
  const closeFAQPopup = () => setIsFAQOpen(false);

  return (
    <footer className="bg-[#482F1E] text-white py-8">
      {/* Logo Section */}
      <div className="flex justify-center items-center mb-6">
        <img
          src="./fulllogo_transparent.png" // Replace with the path to your logo
          alt="Radiant Light Healing Logo"
          className="w-24 h-24 sm:w-32 sm:h-32 object-contain transition-transform duration-300 hover:scale-105"
        />
      </div>

      {/* Content Section */}
      <div className="container mx-auto text-center">
        <nav className="mt-6 space-x-4 sm:space-x-8 text-sm">
          <a href="#about" className="hover:text-gray-400 font-karla">About</a>
          <a href="#reiki" className="hover:text-gray-400 font-karla">Reiki</a>
          <a href="#testimonials" className="hover:text-gray-400 font-karla">Testimonials</a>
          <a href="#pricing" className="hover:text-gray-400 font-karla">Pricing</a>
          <a href="#contact-us" className="hover:text-gray-400 font-karla">Contact</a>
          <button type="button" onClick={openFAQPopup} className="hover:text-gray-400 font-karla">FAQs</button>
        </nav>

        <div className="mt-6 text-sm text-gray-300 font-karla">
          <p>© {new Date().getFullYear()} Radiant Light Healing | Made with <span>❤️</span> by Vivek</p>
        </div>
      </div>

      {/* Social Media Icons Section */}
      <div className="flex justify-center mt-6 space-x-6">
        <a href="https://www.instagram.com/radiantlighthealing2024" target="_blank" rel="noopener noreferrer" className="text-about-me-orange text-3xl hover:text-gray-400">
          <FaInstagram aria-label="Instagram" role="img" />
        </a>
        <a href="https://www.linkedin.com/in/ankita-singh-16931091/" target="_blank" rel="noopener noreferrer" className="text-about-me-orange text-3xl hover:text-gray-400">
          <FaLinkedin aria-label="LinkedIn" role="img" />
        </a>
        <a href="https://www.youtube.com/channel/UCyE_Lj-F1uaJr55f7VEYGCw" target="_blank" rel="noopener noreferrer" className="text-about-me-orange text-3xl hover:text-gray-400">
          <FaYoutube aria-label="YouTube" role="img" />
        </a>
        <a href="https://reiki.ca/practitioners-teachers/practitioner-teacher-directory/#/action/Listing/value/34204/searchID/593515/cid/1269/id/2501/Ankita-Singh" className="text-about-me-orange text-3xl hover:text-gray-400" target="_blank" rel="noopener noreferrer" title="Canadian Reiki Association Profile">
          <FaUserCircle aria-label="Canadian Reiki Association profile" role="img" />
        </a>
      </div>

      {/* FAQ Popup */}
      <FAQPopup isOpen={isFAQOpen} closePopup={closeFAQPopup} />
    </footer>
  );
};

export default Footer;